module.exports = __webpack_public_path__ + "static/media/SPONSORS (1).6d22d23c.png";